export default __webpack_public_path__ + "static/media/new-cocoon.8769115c.png";